'use client';
import { useEffect } from "react";

export default function IntakerScript() {
  useEffect(() => {
    // avoid double-inject (StrictMode / hot reload / route changes)
    if (document.querySelector('script[data-intaker="1"]')) return;

    // set config before loading
    window.Intaker = window.Intaker || {};
    window.Intaker.odl = "thehusbandwifelawteam";

    const s = document.createElement("script");
    s.src = "https://intaker.azureedge.net/widget/chat.min.js";
    s.async = true;
    s.setAttribute("data-intaker", "1");
    document.head.appendChild(s);
  }, []);

  return null; // nothing to render
}
